<div class="d-flex flex-column position-relative">
  <ngx-loading [show]="loading"></ngx-loading>
  <div class="d-flex flex-column pb-2">
    <span class="teal-font"> Images with the following extensions are supported: png, jpg, jpeg </span>
    <div kendoTooltip [tooltipTemplate]="emojiTemplate" filter="i" position="right">
      Dimensions <i class="fa fa-question-circle teal-font" style="font-size: 12px"></i>
    </div>
    <ng-template #emojiTemplate>
      <span>
        The image will be resized to either 1500px width or 750px height, which ever comes first, maintaining aspect
        ratio
      </span>
      <br />
      <span>
        Displayed image is resized to either 500px width or 250px height, which ever comes first, maintaining aspect
        ratio
      </span>
    </ng-template>
  </div>
  <div class="d-flex mb-2">
    <img class="img-fluid"
      [src]="clinicLogo ? (clinicLogo | safeUrl) : '/assets/Avatars/clinic-logo.png'"      
    />
  </div>
  <div class="d-flex justify-content-end py-2">
    <input #imageUpload class="d-none" (change)="onFileSelected($event)" type="file" accept="image/*" />
    <button
      class="btn medium em-btn em-btn-green mr-2"
      type="button"
      (click)="imageUpload.click()"
      [disabled]="!selectedClinic"
    >
      <i class="far fa-upload"></i> Upload
    </button>
    <button
      class="btn medium em-btn em-btn-green"
      type="button"
      (click)="removeLogo()"
      [disabled]="!clinicLogo || !selectedClinic"
    >
      <i class="far fa-times"></i> Remove
    </button>
  </div>
</div>
